import { PurchasingRepository } from '@Purchasing/Data/Repository/PurchasingRepository'
import { ProductionLinksResult } from '@Purchasing/Domain/Model/PurchaseProcess'

export class GetProductionLinksUseCase {
    constructor(private repository: PurchasingRepository) {}
    execute(processId: string): Promise<ProductionLinksResult> {
        return this.repository.getProduction(processId)
    }
}

export class ConfirmProductionLinkUseCase {
    constructor(private repository: PurchasingRepository) {}
    execute(processId: string, productionId: string): Promise<void> {
        return this.repository.confirmProduction(processId, productionId)
    }
}

export class RefreshProductionUseCase {
    constructor(private repository: PurchasingRepository) {}
    execute(processId: string): Promise<void> {
        return this.repository.refreshProduction(processId)
    }
}

export class UnlinkProductionLinkUseCase {
    constructor(private repository: PurchasingRepository) {}
    execute(processId: string, productionId: string): Promise<void> {
        return this.repository.unlinkProduction(processId, productionId)
    }
}
